"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferFieldContractType = OfferFieldContractType;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const config_1 = require("@src/config");
const offer_1 = require("@src/types/offer");
function OfferFieldContractType() {
    const intl = (0, react_intl_1.useIntl)();
    const config = (0, config_1.getConfig)(intl.locale);
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { noStyle: true, shouldUpdate: (prevValues, curValues) => prevValues[offer_1.EOfferBasicInfoFormField.offerTypeId] !== curValues[offer_1.EOfferBasicInfoFormField.offerTypeId], children: ({ getFieldValue }) => {
            const shouldBeHidden = getFieldValue(offer_1.EOfferBasicInfoFormField.offerTypeId) !== offer_1.EOfferType.permanent;
            return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { hidden: shouldBeHidden, label: intl.formatMessage({
                    id: 'admin.offer_form.contract_type',
                }), name: offer_1.EOfferBasicInfoFormField.contractTypeId, rules: [
                    {
                        required: !shouldBeHidden,
                        message: intl.formatMessage({
                            id: 'admin.offer_validation.please_select_contract_type',
                        }),
                    },
                ], children: (0, jsx_runtime_1.jsx)(antd_1.Select, { placeholder: intl.formatMessage({
                        id: 'admin.offer_form.choose',
                    }), showArrow: true, optionFilterProp: "children", children: config.contractTypes.map(cType => ((0, jsx_runtime_1.jsx)(antd_1.Select.Option, { value: cType.value, children: cType.label }, cType.value))) }) }));
        } }));
}
